/** Given names and surnames for regions whose full content isn't written yet. */
export const NAMES: Record<string, { m: string[]; f: string[]; surname: string[]; surnameFirst?: boolean }> = {
  us: {
    m: ['James', 'Marcus', 'Daniel', 'Tyler', 'Andre', 'Luis', 'Kevin', 'Brandon', 'Jordan', 'Ethan', 'Carlos', 'Malik', 'Ryan', 'Noah'],
    f: ['Ashley', 'Jasmine', 'Emily', 'Maria', 'Brianna', 'Sarah', 'Destiny', 'Hannah', 'Sofia', 'Kayla', 'Megan', 'Aaliyah', 'Grace', 'Olivia'],
    surname: ['Johnson', 'Williams', 'Garcia', 'Miller', 'Davis', 'Rodriguez', 'Brown', 'Martinez', 'Wilson', 'Anderson', 'Thomas', 'Jackson', 'Nguyen', 'Patel'],
  },
  japan: {
    m: ['Haruto', 'Ren', 'Sota', 'Yuto', 'Kaito', 'Riku', 'Takumi', 'Daiki', 'Kenta', 'Shota'],
    f: ['Yui', 'Hina', 'Aoi', 'Sakura', 'Mei', 'Rin', 'Yuna', 'Miyu', 'Akari', 'Nanami'],
    surname: ['Sato', 'Suzuki', 'Takahashi', 'Tanaka', 'Watanabe', 'Ito', 'Yamamoto', 'Nakamura', 'Kobayashi', 'Kato'],
  },
  uae: {
    m: ['Mohammed', 'Ahmed', 'Omar', 'Khalid', 'Rashid', 'Saeed', 'Hamdan', 'Zayed', 'Yousef', 'Ali', 'Faisal', 'Hassan'],
    f: ['Fatima', 'Maryam', 'Aisha', 'Sara', 'Noor', 'Layla', 'Hessa', 'Shamma', 'Mahra', 'Dana', 'Reem', 'Amna'],
    surname: ['Al Mansoori', 'Al Falasi', 'Al Nuaimi', 'Al Suwaidi', 'Al Mazrouei', 'Al Hashimi', 'Al Ketbi', 'Al Shamsi', 'Al Marri', 'Al Dhaheri'],
  },
  italy: {
    m: ['Lorenzo', 'Matteo', 'Alessandro', 'Leonardo', 'Francesco', 'Riccardo', 'Tommaso', 'Gabriele', 'Marco', 'Giovanni', 'Davide', 'Pietro'],
    f: ['Giulia', 'Sofia', 'Aurora', 'Alice', 'Ginevra', 'Beatrice', 'Chiara', 'Martina', 'Francesca', 'Elena', 'Viola', 'Matilde'],
    surname: ['Rossi', 'Bianchi', 'Ricci', 'Romano', 'Colombo', 'Bruno', 'Conti', 'Greco', 'Gallo', 'Marini', 'Lombardi', 'Fontana', 'Moretti', 'Barbieri'],
  },
  china: {
    m: ['Wei', 'Hao', 'Jun', 'Lei', 'Yang', 'Chen', 'Ming', 'Tao', 'Bo', 'Zhi'],
    f: ['Mei', 'Xin', 'Yan', 'Jing', 'Li', 'Fang', 'Ying', 'Lan', 'Hui', 'Xiu'],
    surname: ['Wang', 'Li', 'Zhang', 'Liu', 'Chen', 'Yang', 'Huang', 'Zhao', 'Wu', 'Zhou'],
    surnameFirst: true,
  },
};
